import React, { Component, Fragment } from "react";
import { Navbar, Container, Row, Col } from "react-bootstrap";

import Link from "./Link";
import "./NavBar.scss";

class NavBar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            sticky: null,
            mainPage: window.location.pathname
        };
    }

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener("resize", this.handleResize);
        this.setState({ sticky: this.refs.navbar.offsetTop });
    }

    handleResize = () => {
        if (this.refs.navbar) {
            if (this.refs.navbar.classList.contains("sticky")) {
                this.setState({ sticky: this.refs.navbarFill.offsetTop });
            } else {
                this.setState({ sticky: this.refs.navbar.offsetTop });
            }
        }
    };

    handleScroll = () => {
        // Sticky Navbar
        if (this.refs.navbar) {
            if (window.pageYOffset >= this.state.sticky) {
                this.refs.navbar.classList.add("sticky");
                this.refs.navbarFill.classList.add("fill");
            } else {
                this.refs.navbar.classList.remove("sticky");
                this.refs.navbarFill.classList.remove("fill");
            }
        }
    };

    render() {

        let logo = this.state.data.logo;

        return (
            <Fragment>
                <div id="navbar" ref="navbar">
                    <Navbar expand="sm">
                        <Container>
                            <Row>
                                <Navbar.Toggle aria-controls="basic-navbar-nav" />

                                <Col className="logo-collapse">
                                    <Link
                                        link="/"
                                        hash="#intro"
                                        className="link"
                                    >
                                        <img src={`/images/${logo}`} alt="" />
                                    </Link>
                                </Col>
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <Col>
                                        <Link
                                            link="/"
                                            hash="#career"
                                            className="link"
                                        >
                                            CAREER
                                            <div className="link-select" />
                                        </Link>
                                    </Col>
                                    <Col>
                                        <Link
                                            link="/"
                                            hash="#skills"
                                            className="link"
                                        >
                                            SKILLS
                                            <div className="link-select" />
                                        </Link>
                                    </Col>
                                </Navbar.Collapse>
                                <Col className="logo">
                                    <Link
                                        link="/"
                                        hash="#intro"
                                        className="link"
                                    >
                                        <img src={`/images/${logo}`} alt="" />
                                    </Link>
                                </Col>
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <Col>
                                        <Link
                                            link="/"
                                            hash="#projects"
                                            className="link"
                                        >
                                            PROJECTS
                                            <div className="link-select" />
                                        </Link>
                                    </Col>
                                    <Col>
                                        <Link
                                            link="/"
                                            hash="#contact"
                                            className="link"
                                        >
                                            CONTACT
                                            <div className="link-select" />
                                        </Link>
                                    </Col>
                                </Navbar.Collapse>
                            </Row>
                        </Container>
                    </Navbar>
                </div>
                <div className="navbar-fill" ref="navbarFill" />
            </Fragment >
        );
    }
}

export default NavBar;
